import QuestionBox from "../ui/QuestionBox"

type WipoDasSectionProps = {
  wipoDasOpen: boolean
  setWipoDasOpen: (value: boolean) => void
  wipoDasAccepted: boolean
  setWipoDasAccepted: (value: boolean) => void
}

export default function WipoDasSection({
  wipoDasOpen,
  setWipoDasOpen,
  wipoDasAccepted,
  setWipoDasAccepted
}: WipoDasSectionProps) {
  return (
    <div className="border-b-2 border-dashed border-gray-300 py-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setWipoDasOpen(!wipoDasOpen)}
          className={`relative h-8 w-16 rounded-full transition-colors ${
            wipoDasOpen ? "bg-blue-800" : "bg-gray-400"
          }`}
        >
          <span
            className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white transition-transform ${
              wipoDasOpen ? "translate-x-8" : "translate-x-0"
            }`}
          />
        </button>

        <h4 className="text-lg font-semibold text-blue-800">
          WIPO DAS
        </h4>

        <QuestionBox title="WIPO DAS">
          Your application will be registered in the WIPO DAS system. After
          successful filing you will receive a WIPO DAS code, which you can use
          for later applications to claim priority without submitting certified
          copies. More information is available at https://www.wipo.int/das
        </QuestionBox>
      </div>

      {wipoDasOpen && (
        <div className="mt-5 rounded bg-gray-50 px-4 py-4">
          <label className="flex items-center gap-3 text-sm text-gray-800">
            <input
              type="checkbox"
              checked={wipoDasAccepted}
              onChange={(event) =>
                setWipoDasAccepted(event.target.checked)
              }
              className="h-4 w-4 accent-blue-800"
            />
            I want to use the WIPO DAS system to exchange priority documents for
            this EU design.
          </label>
        </div>
      )}
    </div>
  )
}
